import { paths } from '@/config/paths'
import { AppSidebar, Nav } from '@/components/sidebar/sidebar'
import { Package, ShieldBan, Grip, Layers, Settings, Users, MapPinned, ChartColumnBig } from 'lucide-react'

const GLOBAL_SECURITY_NAV: Nav = [
  {
    items: [
      {
        title: 'Dashboard',
        url: paths.admin.dashboard.getHref(),
        Icon: Grip,
        isEnd: true,
      },
    ],
  },
  {
    title: 'Tracking',
    items: [
      {
        title: 'Stock',
        url: paths.admin.parts.list.getHref(),
        Icon: Layers,
      },
      {
        title: 'Packages',
        url: paths.admin.packages.list.getHref(),
        Icon: Package,
      },
    ],
  },
  {
    title: 'App',
    items: [
      {
        title: 'Locations',
        url: paths.admin.locations.getHref(),
        Icon: MapPinned,
      },
      {
        title: 'Users',
        url: paths.admin.users.getHref(),
        Icon: Users,
      },
      {
        title: 'Settings',
        url: paths.admin.settings.customProperties.getHref(),
        Icon: Settings,
      },
    ],
  },
  {
    title: 'Security',
    items: [
      {
        title: 'Statistics',
        url: paths.admin.statistics.getHref(),
        Icon: ChartColumnBig,
      },
      {
        title: 'Incidents',
        url: paths.admin.incidents.getHref(),
        Icon: ShieldBan,
      },
    ],
  },
]

export const GlobalSidebar = () => {
  return <AppSidebar nav={GLOBAL_SECURITY_NAV} />
}
